import * as s from "./mockup-iphone.module.less";
import iPhoneImage from "../../../media/mockups/iphone.png";
import React from "react";
import {GatsbyImage as Img, getImage} from "gatsby-plugin-image";

const MockupIPhone = ({
	screenShot,
	companyName
}) => {
	return (
		<div className={s.mockup}>
			<img
				src={iPhoneImage}
				alt={`${companyName} media`}
				className={s.mockImage}
			/>
			<div
				className={s.mediaElement}
			>
				<Img
					image={getImage(screenShot)}
					alt={`${companyName} media`}
				/>
			</div>
		</div>
	)
}
export default MockupIPhone;
